import { render, staticRenderFns } from "./indexJF.vue?vue&type=template&id=5c5ec933&scoped=true&"
import script from "./indexJF.vue?vue&type=script&lang=js&"
export * from "./indexJF.vue?vue&type=script&lang=js&"
import style0 from "./indexJF.vue?vue&type=style&index=0&id=5c5ec933&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ec933",
  null
  
)

export default component.exports